import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { format } from 'date-fns';
import { enUS, es, fr, he, it } from 'date-fns/locale';

export const getLocaleSet = (locale?: string) => {
  const lang = locale || localStorage.getItem('language') || 'en';

  switch (lang) {
    case 'he':
      return he;
    case 'es':
      return es;
    case 'it':
      return it;
    case 'fr':
      return fr;
    default:
      return enUS;
  }
};

export const dateFormat = (date: Date | string | undefined, formatStr: string, locale?: string) => {
  const dateObj = typeof date === 'string' ? new Date(date) : date;
  const localeSet = getLocaleSet(locale);
  if (dateObj instanceof Date && isNaN(dateObj.getTime())) return '';

  return format(dateObj || new Date(), formatStr, { locale: localeSet });
};

export interface i18nConfigProps {
  enTranslation: any;
  heTranslation: any;
  ruTranslation?: any;
  itTranslation?: any;
  esTranslation?: any;
  frTranslation?: any;
}

export const i18nConfig = (props: i18nConfigProps) => {
  const lang = localStorage.getItem('language');

  i18n.use(initReactI18next).init({
    resources: {
      en: {
        translation: props.enTranslation,
      },
      he: {
        translation: props.heTranslation,
      },
      ru: {
        translation: props.ruTranslation,
      },
      it: {
        translation: props.itTranslation || {},
      },
      es: {
        translation: props.esTranslation || {},
      },
      fr: {
        translation: props.frTranslation || {},
      },
    },
    lng: lang ? lang : 'he',
    fallbackLng: 'he',

    interpolation: {
      escapeValue: false,
    },
  });
};

interface GetGooglePredictionParams {
  query: string;
  prefix: string;
}
export const getGooglePrediction = async (
  params: GetGooglePredictionParams,
  signal: any,
): Promise<any[]> => {
  try {
    const isLocalhost =
      window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const devUrl = localStorage.getItem('devUrl') || 'https://enigma-hotels.com';
    const url = isLocalhost
      ? `${devUrl}/backend/Utils/GetGooglePrediction`
      : '/backend/Utils/GetGooglePrediction';

    const user = localStorage.getItem('user');
    const userJson = user ? JSON.parse(user) : '';
    const cognito = localStorage.getItem('cognito');
    const cognitoJson = cognito ? JSON.parse(cognito) : '';
    const authorization = user
      ? `Bearer ${userJson?.token || userJson?.accessToken || cognitoJson?.access_token}`
      : '';

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization,
      },
      body: JSON.stringify(params),
      signal,
    });

    if (!res.ok) {
      console.log(res);
      return [];
    }

    const data = await res.json();
    const json = JSON.parse(data.googleResponse);
    return json.predictions;
  } catch (err) {
    return [];
  }
};

interface GetGooglePredictionParams {
  query: string;
  prefix: string;
}
export const getGooglePredictionDetails = async (placeId: string): Promise<any[]> => {
  try {
    const isLocalhost =
      window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
    const devUrl = localStorage.getItem('devUrl') || 'https://enigma-hotels.com';
    const url = isLocalhost
      ? `${devUrl}/backend/Utils/GetGooglePredictionDetails`
      : '/backend/Utils/GetGooglePredictionDetails';

    const user = localStorage.getItem('user');
    const userJson = user ? JSON.parse(user) : '';
    const cognito = localStorage.getItem('cognito');
    const cognitoJson = cognito ? JSON.parse(cognito) : '';
    const authorization = user
      ? `Bearer ${userJson?.token || userJson?.accessToken || cognitoJson?.access_token}`
      : '';

    const res = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        authorization,
      },
      body: JSON.stringify({ placeId }),
    });

    if (!res.ok) {
      console.log(res);
    }

    const data = await res.json();

    const json = JSON.parse(data.googleResponse);
    return json;
  } catch (err) {
    return [];
  }
};
